import React from "react";
import { formatNumber } from "../../utils";

const InfoTimeCardAdv = ({
  variant = "text", // text,contained, outlined, titleContained, valueContained
  title = "title",
  value = "1236548756",
  prefix = "",
  suffix = "",
  size = "md", //xs, xs-sm, sm, md, lg, xl
  affixSize = "xs", //xs, xs-sm, sm, md, lg, xl
  color = "black", // primary, warning, success, danger, info, black, white
  type = "type1", //type1, type2, type3
  oneLine = false,
  align = "left", //left, center, right
  onClick,
}) => {
  // Comprehensive color styles based on variant and color
  const colorStyles = {
    text: {
      primary: {
        value: "text-primary",
        title: "text-gray-500",
        affix: "text-primary",
        border: "border-[1px] border-gray-200",
        bg: "bg-white",
      },
      warning: {
        value: "text-warning",
        title: "text-gray-500",
        affix: "text-warning",
        border: "border-[1px] border-gray-200",
        bg: "bg-white",
      },
      success: {
        value: "text-success",
        title: "text-gray-500",
        affix: "text-success",
        border: "border-[1px] border-gray-200",
        bg: "bg-white",
      },
      danger: {
        value: "text-danger",
        title: "text-gray-500",
        affix: "text-danger",
        border: "border-[1px] border-gray-200",
        bg: "bg-white",
      },
      info: {
        value: "text-info",
        title: "text-gray-500",
        affix: "text-info",
        border: "border-[1px] border-gray-200",
        bg: "bg-white",
      },
      black: {
        value: "text-black",
        title: "text-gray-500",
        affix: "text-black",
        border: "border-[1px] border-gray-200",
        bg: "bg-white",
      },
      white: {
        value: "text-gray-400",
        title: "text-gray-500",
        affix: "text-gray-400",
        border: "border-[1px] border-gray-200",
        bg: "bg-white",
      },
    },
    contained: {
      primary: {
        value: "text-white",
        title: "text-white",
        affix: "text-white",
        border: "border-[1px] border-primary",
        bg: "bg-primary",
      },
      warning: {
        value: "text-white",
        title: "text-white",
        affix: "text-white",
        border: "border-[1px] border-warning",
        bg: "bg-warning",
      },
      success: {
        value: "text-white",
        title: "text-white",
        affix: "text-white",
        border: "border-[1px] border-success",
        bg: "bg-success",
      },
      danger: {
        value: "text-white",
        title: "text-white",
        affix: "text-white",
        border: "border-[1px] border-danger",
        bg: "bg-danger",
      },
      info: {
        value: "text-white",
        title: "text-white",
        affix: "text-white",
        border: "border-[1px] border-info",
        bg: "bg-info",
      },
      black: {
        value: "text-white",
        title: "text-white",
        affix: "text-white",
        border: "border-[1px] border-black",
        bg: "bg-black",
      },
      white: {
        value: "text-black",
        title: "text-black",
        affix: "text-black",
        border: "border-[1px] border-white",
        bg: "bg-white",
      },
    },
    outlined: {
      primary: {
        value: "text-primary",
        title: "text-primary",
        affix: "text-primary",
        border: "border-[1px] border-primary",
        bg: "bg-transparent",
      },
      warning: {
        value: "text-warning",
        title: "text-warning",
        affix: "text-warning",
        border: "border-[1px] border-warning",
        bg: "bg-transparent",
      },
      success: {
        value: "text-success",
        title: "text-success",
        affix: "text-success",
        border: "border-[1px] border-success",
        bg: "bg-transparent",
      },
      danger: {
        value: "text-danger",
        title: "text-danger",
        affix: "text-danger",
        border: "border-[1px] border-danger",
        bg: "bg-transparent",
      },
      info: {
        value: "text-info",
        title: "text-info",
        affix: "text-info",
        border: "border-[1px] border-info",
        bg: "bg-transparent",
      },
      black: {
        value: "text-black",
        title: "text-black",
        affix: "text-black",
        border: "border-[1px] border-black",
        bg: "bg-transparent",
      },
      white: {
        value: "text-white",
        title: "text-white",
        affix: "text-white",
        border: "border-[1px] border-white",
        bg: "bg-transparent",
      },
    },
    titleContained: {
      primary: {
        value: "text-primary",
        title: "text-white",
        affix: "text-primary",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-primary",
        valueBg: "bg-white",
      },
      warning: {
        value: "text-warning",
        title: "text-white",
        affix: "text-warning",
        border: "border-[1px]  border-gray-200",
        titleBg: "bg-warning",
        valueBg: "bg-white",
      },
      success: {
        value: "text-success",
        title: "text-white",
        affix: "text-success",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-success",
        valueBg: "bg-white",
      },
      danger: {
        value: "text-danger",
        title: "text-white",
        affix: "text-danger",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-danger",
        valueBg: "bg-white",
      },
      info: {
        value: "text-info",
        title: "text-white",
        affix: "text-info",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-info",
        valueBg: "bg-white",
      },
      black: {
        value: "text-black",
        title: "text-white",
        affix: "text-black",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-black",
        valueBg: "bg-white",
      },
      white: {
        value: "text-gray-400",
        title: "text-black",
        affix: "text-gray-400",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-white",
        valueBg: "bg-white",
      },
    },
    valueContained: {
      primary: {
        value: "text-white",
        title: "text-gray-500",
        affix: "text-white",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-white",
        valueBg: "bg-primary",
      },
      warning: {
        value: "text-white",
        title: "text-gray-500",
        affix: "text-white",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-white",
        valueBg: "bg-warning",
      },
      success: {
        value: "text-white",
        title: "text-gray-500",
        affix: "text-white",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-white",
        valueBg: "bg-success",
      },
      danger: {
        value: "text-white",
        title: "text-gray-500",
        affix: "text-white",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-white",
        valueBg: "bg-danger",
      },
      info: {
        value: "text-white",
        title: "border-[1px] text-gray-500",
        affix: "text-white",
        border: "border-gray-200",
        titleBg: "bg-white",
        valueBg: "bg-info",
      },
      black: {
        value: "text-white",
        title: "text-gray-500",
        affix: "text-white",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-white",
        valueBg: "bg-black",
      },
      white: {
        value: "text-black",
        title: "text-gray-500",
        affix: "text-black",
        border: "border-[1px] border-gray-200",
        titleBg: "bg-white",
        valueBg: "bg-white",
      },
    },
  };

  const sizeStyles = {
    fontSize: {
      xs: "text-[16px] leading-none",
      "xs-sm": "text-[20px] leading-none",
      sm: "text-[24px] leading-none",
      md: "text-[28px] leading-none",
      lg: "text-[32px] leading-none",
      xl: "text-[40px] leading-none",
    },
  };

  ////////////////////////////////////////////////////////////////////////

  const colorStylesTwo = {
    // primary, warning, success, danger, info, black, white
    titleContained: {},
    valueContained: {},
    contained: {
      primary: {
        bg: "bg-primary",
        border: "border-[1px] border-primary",
        prefix: "text-primary",
        prefixBg: "bg-white",
        value: "text-white",
        suffix: "text-white",
      },
      warning: {
        bg: "bg-warning",
        border: "border-[1px] border-warning",
        prefix: "text-warning",
        prefixBg: "bg-white",
        value: "text-white",
        suffix: "text-white",
      },
      success: {
        bg: "bg-success",
        border: "border-[1px] border-success",
        prefix: "text-success",
        prefixBg: "bg-white",
        value: "text-white",
        suffix: "text-white",
      },
      danger: {
        bg: "bg-danger",
        border: "border-[1px] border-danger",
        prefix: "text-danger",
        prefixBg: "bg-white",
        value: "text-white",
        suffix: "text-white",
      },
      info: {
        bg: "bg-info",
        border: "border-[1px] border-info",
        prefix: "text-info",
        prefixBg: "bg-white",
        value: "text-white",
        suffix: "text-white",
      },
      black: {
        bg: "bg-black",
        border: "border-[1px] border-black",
        prefix: "text-black",
        prefixBg: "bg-white",
        value: "text-white",
        suffix: "text-white",
      },
      white: {
        bg: "bg-white",
        border: "border-[1px] border-white",
        prefix: "text-black",
        prefixBg: "bg-white",
        value: "text-black",
        suffix: "text-black",
      },
    },
    outlined: {
      primary: {
        bg: "bg-transparent",
        border: "border-[1px] border-primary",
        prefix: "text-primary",
        prefixBg: "bg-primary-50",
        value: "text-primary",
        suffix: "text-primary",
      },
      warning: {
        bg: "bg-transparent",
        border: "border-[1px] border-warning",
        prefix: "text-warning",
        prefixBg: "bg-warning-50",
        value: "text-warning",
        suffix: "text-warning",
      },
      success: {
        bg: "bg-transparent",
        border: "border-[1px] border-success",
        prefix: "text-success",
        prefixBg: "bg-success-50",
        value: "text-success",
        suffix: "text-success",
      },
      danger: {
        bg: "bg-transparent",
        border: "border-[1px] border-danger",
        prefix: "text-danger",
        prefixBg: "bg-danger-50",
        value: "text-danger",
        suffix: "text-danger",
      },
      info: {
        bg: "bg-transparent",
        border: "border-[1px] border-info",
        prefix: "text-info",
        prefixBg: "bg-info-50",
        value: "text-info",
        suffix: "text-info",
      },
      black: {
        bg: "bg-transparent",
        border: "border-[1px] border-black",
        prefix: "text-black",
        prefixBg: "bg-info-50",
        value: "text-black",
        suffix: "text-black",
      },
      white: {
        bg: "bg-black",
        border: "border-[1px] border-black",
        prefix: "text-white",
        prefixBg: "bg-white",
        value: "text-white",
        suffix: "text-white",
      },
    },
    text: {
      primary: {
        bg: "bg-transparent",
        border: "border-[1px] border-transparent",
        prefix: "text-primary",
        prefixBg: "bg-primary-50",
        value: "text-primary",
        suffix: "text-primary",
      },
      warning: {
        bg: "bg-transparent",
        border: "border-[1px] border-transparent",
        prefix: "text-warning",
        prefixBg: "bg-warning-50",
        value: "text-warning",
        suffix: "text-warning",
      },
      success: {
        bg: "bg-transparent",
        border: "border-[1px] border-transparent",
        prefix: "text-success",
        prefixBg: "bg-success-50",
        value: "text-success",
        suffix: "text-success",
      },
      danger: {
        bg: "bg-transparent",
        border: "border-[1px] border-transparent",
        prefix: "text-danger",
        prefixBg: "bg-danger-50",
        value: "text-danger",
        suffix: "text-danger",
      },
      info: {
        bg: "bg-transparent",
        border: "border-[1px] border-transparent",
        prefix: "text-info",
        prefixBg: "bg-info-50",
        value: "text-info",
        suffix: "text-info",
      },
      black: {
        bg: "bg-transparent",
        border: "border-[1px] border-transparent",
        prefix: "text-black",
        prefixBg: "bg-info-50",
        value: "text-black",
        suffix: "text-black",
      },
      white: {
        bg: "bg-transparent",
        border: "border-[1px] border-transparent",
        prefix: "text-black",
        prefixBg: "bg-transparent",
        value: "text-black",
        suffix: "text-black",
      },
    },
  };

  const sizeStylesTwo = {
    fontPrefixSize: {
      xs: "text-[24px] leading-none",
      "xs-sm": "text-[24px] leading-none",
      sm: "text-[24px] leading-none",
      md: "text-[24px] leading-none",
      lg: "text-[24px] leading-none",
      xl: "text-[24px] leading-none",
    },
    fontValueSize: {
      xs: "text-[16px] leading-none",
      "xs-sm": "text-[18px] leading-none",
      sm: "text-[22px] leading-none",
      md: "text-[24px] leading-none",
      lg: "text-[28px] leading-none",
      xl: "text-[32px] leading-none",
    },
    fontSurfixSize: {
      xs: "text-[14px] leading-none",
      "xs-sm": "text-[16px] leading-none",
      sm: "text-[18px] leading-none",
      md: "text-[20px] leading-none",
      lg: "text-[24px] leading-none",
      xl: "text-[28px] leading-none",
    },
  };

  // Get the appropriate styles based on variant and color
  const styles = colorStyles[variant][color];
  const stylesTwo = colorStylesTwo[variant][color];

  // switch basedon type
  const renderContent = () => {
    switch (type) {
      case "type1":
        return (
          <div
            className={`flex gap-0.5 overflow-hidden  ${
              styles.border
            } rounded-md shadow-md ${
              variant === "contained" ? styles.bg : "bg-white"
            } ${oneLine === true ? "py-2" : "flex-col"}
        ${
          variant === "text" ||
          variant === "outlined" ||
          variant === "contained"
            ? "gap-2"
            : " gap-0.5"
        } 
        ${
          // oneLine === true
          //   ? align === "left"
          //     ? "justify-start"
          //     : align === "center"
          //     ? "justify-center"
          //     : "justify-end"
          //   : align === "left"
          //   ? "items-start"
          //   : align === "center"
          //   ? "items-center"
          //   : "items-end"
          1 === 1 && "one"
        }
        `}
          >
            <div
              className={`leading-tight px-2 text-base font-medium flex-1 flex  w-full py-1.5 ${
                styles.title
              } ${variant === "titleContained" ? `${styles.titleBg}` : ""}
          ${
            variant === "text" ||
            variant === "outlined" ||
            variant === "contained"
              ? "pb-0"
              : ""
          }
          ${
            align === "left"
              ? "justify-start"
              : align === "center"
              ? "justify-center"
              : "justify-end"
          }
          ${oneLine === true ? "items-start" : ""}
          `}
            >
              {title}
            </div>
            <div
              className={`flex gap-0.5 items-end !leading-none px-2 py-1.5 ${
                variant === "valueContained" ? `${styles.valueBg}` : ""
              }
           ${
             variant === "text" ||
             variant === "outlined" ||
             variant === "contained"
               ? "pt-0"
               : ""
           }
           ${
             align === "left"
               ? "justify-start"
               : align === "center"
               ? "justify-center"
               : "justify-end"
           }
          `}
            >
              <div
                className={`${sizeStyles.fontSize[affixSize]} ${styles.affix}`}
              >
                {prefix && prefix}
              </div>
              <div
                className={`font-medium tabular-nums ${sizeStyles.fontSize[size]} ${styles.value} ${onClick ? `cursor-pointer` : ``}`}
                onClick={() => {if(onClick){onClick()}}}
              >
                {value}
              </div>
              <div
                className={`${sizeStyles.fontSize[affixSize]} ${styles.affix}`}
              >
                {suffix && suffix}
              </div>
            </div>
          </div>
        );

      case "type2":
        return (
          <div className="flex gap-0.5 overflow-hidden">
            <div
              className={`flex-1 w-full flex gap-2 items-center !leading-none pl-3 pr-4 py-5 rounded-md shadow-md
                ${stylesTwo.border}
                ${variant === "contained" ? stylesTwo.bg : "bg-white"}
                
                `}
            >
              <div
                className={`${sizeStylesTwo.fontPrefixSize[size]} w-10 h-10 rounded-full flex justify-center items-center
                ${stylesTwo.prefixBg} ${stylesTwo.prefix}
                `}
              >
                {prefix && prefix}
              </div>
              <div className="flex items-center gap-1">
                <div
                  className={`font-medium tabular-nums ${sizeStylesTwo.fontValueSize[size]} ${stylesTwo.value}`}
                >
                  {formatNumber(value)}
                  
                </div>
                <div
                  className={`${sizeStylesTwo.fontSurfixSize[affixSize]} ${stylesTwo.suffix}`}
                >
                  {suffix && suffix}
                </div>
              </div>
            </div>
          </div>
        );

      case "type3":
        return (
          <div
            className="flex flex-col py-2 px-4 rounded-2xl text-white bg-gradient-to-tr from-primary-500 from-40% to-primary-200"
            style={{
              boxShadow: "inset 0px 6px 6px -2px #00000040",
            }}
          >
            <div className={`leading-tight px-2  flex-1 flex  w-full py-1.5`}>
              {title}
            </div>
            <div
              className={`flex-1 w-full flex gap-0.5 items-end !leading-none px-2 py-1.5`}
            >
              <div className={`${sizeStyles.fontSize[size]}`}>
                {prefix && prefix}
              </div>
              <div
                className={`font-medium tabular-nums ${sizeStyles.fontSize[size]}`}
              >
                {value}
              </div>
              <div className={`${sizeStyles.fontSize[size]}`}>
                {suffix && suffix}
              </div>
            </div>
          </div>
        );

      default:
        return <div>type1</div>;
    }
  };

  return <div>{renderContent()}</div>;
};

export default InfoTimeCardAdv;
